import React, { Component } from 'react'
import { Segment, Form } from 'semantic-ui-react'

class ReportCaseDeliverySigningSection extends Component {
    render() {
        const { values, onChange } = this.props
        const method = values.deliveryMethod

        return (
            <Segment>
                <Form>
                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Sent To Client Date'
                            value={toDateInput(values.sentToClientDate)}
                            onChange={(e) => onChange('sentToClientDate', e.target.value)}
                        />

                        <Form.Select
                            label='Delivery Method'
                            placeholder='Select method'
                            value={method || ''}
                            options={[
                                { text: 'Courier', value: 'courier' },
                                { text: 'Email', value: 'email' },
                                { text: 'Self Pickup', value: 'self_pickup' },
                                { text: 'Sign Now', value: 'sign_now' }
                            ]}
                            onChange={(e, { value }) => onChange('deliveryMethod', value)}
                        />
                    </Form.Group>

                    {method === 'courier' && (
                        <Form.Input
                            label='Courier Company'
                            value={values.courierCompany || ''}
                            onChange={(e) => onChange('courierCompany', e.target.value)}
                        />
                    )}

                    <Form.Select
                        label='Status – Docs to Return'
                        placeholder='Select status'
                        value={values.deliverySigningStatus || ''}
                        options={[
                            { text: 'Pending Document', value: 'pending_document' },
                            { text: 'Pending Original', value: 'pending_original' }
                        ]}
                        onChange={(e, { value }) => onChange('deliverySigningStatus', value)}
                    />

                    <Form.TextArea
                        label='Comment for Docs to Return'
                        value={values.deliverySigningRemarks || ''}
                        onChange={(e) => onChange('deliverySigningRemarks', e.target.value)}
                    />

                    <Form.Select
                        label='Status – Accounts Records to Return'
                        value={values.documentsReturnStatus}
                        options={[
                            { text: 'Not Required', value: 'not_required' },
                            { text: 'Pending', value: 'pending' },
                            { text: 'Partial', value: 'partial' },
                            { text: 'Completed', value: 'completed' }
                        ]}
                        onChange={(e, { value }) => onChange('documentsReturnStatus', value)}
                    />

                    <Form.TextArea
                        label='Comment for Accounts Records to Return'
                        value={values.incompleteDocsRemark}
                        onChange={(e) => onChange('incompleteDocsRemark', e.target.value)}
                    />

                    <Form.Input
                        type='date'
                        label='Signed Documents Received Date'
                        value={toDateInput(values.signedReceivedDate)}
                        onChange={(e) => onChange('signedReceivedDate', e.target.value)}
                    />
                </Form>
            </Segment>
        )
    }
}

function toDateInput(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export default ReportCaseDeliverySigningSection